import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Card, Row, Col, DatePicker, Pagination } from 'antd'
import _ from 'lodash'
import cx from 'classnames'
import moment from 'moment'
import styles from '../index.css'
import batchStyles from '../BatchUploadImage.css'
import { PROPOSAL_EXECUTE_STATUS_MAP, PROPOSAL_EXECUTE_STATUS } from '@vzmi/shp_shared_compo/constants/proposal'
import { Modal, Toast, Tip, FormLoader } from '@vzmi/shp_shared_compo'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'
import HeadingWithId from '../../Proposal/Common/HeadingWithId/HeadingWithId'
import { withI13nWrapper } from '../../Common/I13nWrapper'
import { HyperLink, When } from '../../Common/Form'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import { httpHandler } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import safeAwait from '../../../../lib/safeAwait'
import errorHelper from '../../../../lib/errorHelper'
import { convertDateByMoment } from '../../../../lib/renderUtil'
import { getISO8601UTC, DATE_FORMAT } from '../../../lib/MomentHelper'
import { pruneEmpty } from '../../../lib/FormHelper'
import { ConnectedListingLink } from '../../Common/ListingLink/ListingLink'
import CollapsePanel from '../../Proposal/UpdateListing/CollapsePanel/CollapsePanel'
import NoData from '../../Common/NoData/NoData'
import { TOAST_DURATION } from '../../../constants/proposalTypes'
import { DEFAULT_REQUEST_SIZE } from '../../Listing/QueryPage/QueryForm/QueryForm'
import { getProposalLink, BATCH_PROPOSAL_TYPE, BATCH_TYPE_LIMIT_MAP, getBatchProposalLink } from '../BatchUploadImage'
import { getRevertBatchTypeStatus, getExecuteBatchTypeStatus } from '../helper/batch'
import SearchForm, { getDefaultFormValues, getSearchParams } from './SearchForm'

const ACTION_TYPE_CANCEL_BATCH = 'cancelBatch'
const ACTION_TYPE_INSTANT_REVERT = 'instantRevert'
const ACTION_TYPE_CANCEL_REVERT = 'cancelRevert'
const ACTION_TYPE_ADJUST_EXECUTE = 'adjustExecuteTs'
const ACTION_TYPE_ADJUST_REVERT = 'adjustRevertTs'
const ACTION_TYPES = {
  [ACTION_TYPE_CANCEL_BATCH]: '整批取消',
  [ACTION_TYPE_INSTANT_REVERT]: '立即回檔',
  [ACTION_TYPE_CANCEL_REVERT]: '取消回檔',
  [ACTION_TYPE_ADJUST_EXECUTE]: '調整圖片修改執行時間',
  [ACTION_TYPE_ADJUST_REVERT]: '調整回檔時間'
}

const NO_FOUND_DESCRIPTION = '查無批次修改圖片'
export const SCHEDULER = 'Scheduler'

const pageSize = DEFAULT_REQUEST_SIZE

const QueryPagination = (props) => {
  const {
    total,
    current,
    onChange,
    visible
  } = props
  if (!visible) {
    return null
  }

  return (
    <div className={styles.queryPagination}>
      <Pagination
        total={total}
        current={current}
        pageSize={pageSize}
        onChange={onChange}
        showSizeChanger={false}
      />
    </div>
  )
}

const BatchProposalQueryMain = (props) => {
  const {
    actions: { fetchBatchProposal, updateBatchProposal, postBatchProposal }
  } = props

  // call fetchBatchProposal and store response data
  const [proposals, setProposals] = useState([])
  const [pagination, setPagination] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const {
    page: pageFromUrl,
    ...queryParams
  } = pruneEmpty(HistoryUtil.retrieveQueryParams(props))
  const defaultPage = (pageFromUrl || 1)
  const defaultSearchParams = getSearchParams(
    getDefaultFormValues(queryParams)
  )
  const [searchParams, setSearchParams] = useState({ page: defaultPage, ...defaultSearchParams })
  const { page: currentPage } = searchParams

  useEffect(() => {
    setIsLoading(true)
    const getBatchProposal = async () => {
      const { page, ...paramsFromForm } = searchParams
      const params = {
        ...paramsFromForm,
        fields: '+details',
        offset: (page - 1) * pageSize,
        limit: pageSize,
        multiple: !_.isEmpty(paramsFromForm.id)
      }
      const [reqError, payload = {}] = await safeAwait(
        fetchBatchProposal(params).then(httpHandler)
      )
      const errorMessage = errorHelper.parseErrorMessage(reqError)
      if (!_.isEmpty(errorMessage)) {
        Toast.error(errorMessage, { duration: TOAST_DURATION })
        setIsLoading(false)
        return
      }

      setProposals(payload.proposals)
      setPagination(payload.pagination)
      setIsLoading(false)
    }

    getBatchProposal()
  }, [fetchBatchProposal, setProposals, searchParams])

  const onPageChange = (page) => {
    const params = { ...searchParams, page }
    updateParams(params)
  }

  const onSearch = (newSearchParams) => {
    const nextPage = newSearchParams.id ? 1 : currentPage
    const params = { ...newSearchParams, page: nextPage }
    updateParams(params)
  }

  const updateParams = params => {
    setSearchParams(params)
    HistoryUtil.updateHistory(params)
  }

  if (isLoading && _.isEmpty(proposals)) {
    return (
      <CommonPage>
        <FormLoader
          isLoading
          fixed
        >
          <div className={styles.topContainer}>
            <HeadingWithId
              title='查看批次修改圖片'
              data-role='batch-uplooadImages-header'
            />
            <SearchForm onSearch={onSearch} />
          </div>
        </FormLoader>
      </CommonPage>
    )
  }

  const isPaginationVisible = pagination && pagination.resultsTotal !== 0
  return (
    <CommonPage>
      <FormLoader
        isLoading={isLoading}
        fixed
      >
        <div className={styles.topContainer}>
          <HeadingWithId
            title='查看批次修改圖片'
            data-role='batch-uplooadImages-header'
          />
          <SearchForm onSearch={onSearch} />
          <QueryPagination
            total={pagination.resultsTotal}
            current={currentPage}
            onChange={onPageChange}
            visible={isPaginationVisible}
          />
          {proposals && proposals.length > 0
            ? proposals.map((item, index) => (
              <BatchCard
                key={index}
                batchId={item.id}
                proposal={item}
                updateBatchProposal={updateBatchProposal}
                postBatchProposal={postBatchProposal}
                setProposals={setProposals}
                setIsLoading={setIsLoading}
              />
            ))
            : !isLoading && (
              <NoData description={NO_FOUND_DESCRIPTION} />
            )
          }
          <QueryPagination
            total={pagination.resultsTotal}
            current={currentPage}
            onChange={onPageChange}
            visible={isPaginationVisible}
          />
        </div>
      </FormLoader>
    </CommonPage>
  )
}

const BatchCard = ({
  batchId,
  proposal,
  updateBatchProposal,
  postBatchProposal,
  setProposals
}) => {
  const {
    executeStatus,
    executeDetail,
    instantExecute,
    executeTs,
    revertTs,
    revertStatus,
    details,
    reverter,
    ...restProposal
  } = proposal
  const [openModal, setOpenModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [modalContent, setModalContent] = useState('')
  const [modalTitle, setModalTitle] = useState('')
  const [actionText, setActionText] = useState('')
  const [okLable, setOkLable] = useState('確認')
  const [cancelLable, setCancelLable] = useState('取消')
  const [newAdjTs, setAdjTs] = useState(null)
  const onCancelBatch = e => {
    setOpenModal(ACTION_TYPE_CANCEL_BATCH)
    setModalContent(`確定取消批次 ${batchId} 修改賣場提案？若有回檔，將連回檔批次一併取消。`)
    setOkLable('確認取消')
    setCancelLable('放棄取消')
    setModalTitle(e.target.innerText)
    setActionText('已送出「批次取消」')
  }
  const onInstantRevert = e => {
    setOpenModal(ACTION_TYPE_INSTANT_REVERT)
    setModalContent(`確認立即回檔批次 ${batchId}？將立即執行回檔提案。`)
    setOkLable('確認')
    setCancelLable('取消')
    setModalTitle(e.target.innerText)
    setActionText('正在立即執行回檔提案，請稍候再查詢執行結果')
  }
  const onCancelRevert = e => {
    setOpenModal(ACTION_TYPE_CANCEL_REVERT)
    setModalContent(`確定取消回檔批次 ${batchId}？將不執行回檔批次提案。`)
    setOkLable('確認取消')
    setCancelLable('放棄取消')
    setModalTitle(e.target.innerText)
    setActionText('已送出「取消回檔」')
  }
  const onAdjustTime = (e, proposalType) => {
    setOpenModal(
      proposalType === BATCH_PROPOSAL_TYPE.EXECUTE
        ? ACTION_TYPE_ADJUST_EXECUTE
        : ACTION_TYPE_ADJUST_REVERT
    )
    setModalContent(<>
      批次&nbsp;
      {batchId}
      <br />
    </>)
    setOkLable('送出修改')
    setCancelLable('取消')
    setModalTitle(e.target.innerText)
    setActionText('已送出調整')
    setAdjTs(moment(proposalType === BATCH_PROPOSAL_TYPE.EXECUTE ? executeTs : revertTs))
  }

  // replace proposals with latest payload data
  const replaceProposals = (payload) => {
    setProposals(prevProposals => {
      const newProposals = prevProposals.map(proposal => {
        if (proposal.id === batchId) {
          return payload
        }
        return proposal
      })
      return newProposals
    })
  }

  const onOK = async () => {
    switch (openModal) {
      case ACTION_TYPE_CANCEL_BATCH: {
        setIsLoading(true)
        const [reqError, payload = {}] = await safeAwait(
          updateBatchProposal({
            id: batchId,
            executeStatus: PROPOSAL_EXECUTE_STATUS.CANCELED
          }).then(httpHandler)
        )
        const errorMessage = errorHelper.parseErrorMessage(reqError)
        setIsLoading(false)
        if (!_.isEmpty(errorMessage)) {
          return Toast.error(errorMessage, { duration: TOAST_DURATION })
        }
        Toast.success(actionText)
        replaceProposals(payload)
      }
        break
      case ACTION_TYPE_INSTANT_REVERT: {
        setIsLoading(true)
        const [reqError] = await safeAwait(
          postBatchProposal({
            id: batchId,
            action: BATCH_PROPOSAL_TYPE.REVERT
          }).then(httpHandler)
        )
        const errorMessage = errorHelper.parseErrorMessage(reqError)
        setIsLoading(false)
        if (!_.isEmpty(errorMessage)) {
          return Toast.error(errorMessage, { duration: TOAST_DURATION })
        }
        Toast.success(actionText)
        // disable button after click
        replaceProposals({
          executeStatus,
          instantExecute,
          executeTs,
          revertTs,
          revertStatus,
          details,
          reverter,
          ...restProposal,
          revertSubmitted: true
        })
      }
        break
      case ACTION_TYPE_CANCEL_REVERT: {
        setIsLoading(true)
        const [reqError, payload = {}] = await safeAwait(
          updateBatchProposal({
            id: batchId,
            revertStatus: PROPOSAL_EXECUTE_STATUS.CANCELED
          }).then(httpHandler)
        )
        const errorMessage = errorHelper.parseErrorMessage(reqError)
        setIsLoading(false)
        if (!_.isEmpty(errorMessage)) {
          return Toast.error(errorMessage, { duration: TOAST_DURATION })
        }
        Toast.success(actionText)
        replaceProposals(payload)
      }
        break

      case ACTION_TYPE_ADJUST_EXECUTE: {
        if (!newAdjTs) {
          return Toast.warn('請選擇預約執行時間')
        }
        const minMoment = moment().add(2, 'hours')
        const maxMoment = moment().add(30, 'days')
        if (
          newAdjTs.isBefore(minMoment) ||
          newAdjTs.isAfter(maxMoment)
        ) {
          return Toast.warn(`預約執行時間須在${BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.EXECUTE]}內`)
        } else if (
          revertTs && newAdjTs.isAfter(revertTs) &&
            revertStatus !== PROPOSAL_EXECUTE_STATUS.CANCELED
        ) {
          return Toast.warn('預約執行時間不可晚於回檔時間')
        }
        setIsLoading(true)
        const [reqError, payload = {}] = await safeAwait(
          updateBatchProposal({
            id: batchId,
            executeTs: getISO8601UTC(newAdjTs)
          }).then(httpHandler)
        )
        setIsLoading(false)
        const errorMessage = errorHelper.parseErrorMessage(reqError)
        if (!_.isEmpty(errorMessage)) {
          return Toast.error(errorMessage, { duration: TOAST_DURATION })
        }
        Toast.success(actionText)
        replaceProposals(payload)
      }
        break

      case ACTION_TYPE_ADJUST_REVERT: {
        if (!newAdjTs) {
          return Toast.warn('請選擇回檔時間')
        }
        const minMoment = moment(executeTs).add(15, 'minutes')
        const minMoment2 = moment().add(3, 'hours')
        const maxMoment = moment().add(60, 'days')
        if (
          newAdjTs.isBefore(minMoment) ||
          newAdjTs.isBefore(minMoment2) ||
          newAdjTs.isAfter(maxMoment)
        ) {
          return Toast.warn(`回檔時間${BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.REVERT]}`)
        }

        setIsLoading(true)
        const [reqError, payload = {}] = await safeAwait(
          updateBatchProposal({
            id: batchId,
            revertTs: getISO8601UTC(newAdjTs)
          }).then(httpHandler)
        )
        setIsLoading(false)
        const errorMessage = errorHelper.parseErrorMessage(reqError)
        if (!_.isEmpty(errorMessage)) {
          return Toast.error(errorMessage, { duration: TOAST_DURATION })
        }
        Toast.success(actionText)
        replaceProposals(payload)
        break
      }

      default:
        break
    }
    setOpenModal(false)
  }
  const onCancel = () => setOpenModal(false)

  return (
    <CollapsePanel
      className={cx(styles.container, batchStyles.batchCard)}
      // 除了尚未開始、已執行待回檔的狀態，其他的卡片預設都關閉
      defaultExpanded={
        executeStatus === PROPOSAL_EXECUTE_STATUS.IDLE ||
        revertStatus === PROPOSAL_EXECUTE_STATUS.IDLE
      }
      panelHeader={(
        <Row
          type='flex'
          align='middle'
          justify='space-between'
          className={styles.panelHeader}
        >
          <Col span={3}>
            批次修改圖片編號
            <div className={styles.listingId}>
              <HyperLink
                className={batchStyles.listingId}
              >
                {batchId}
              </HyperLink>
            </div>
          </Col>
          <Col span={7}>
            {instantExecute
              ? '修改圖片提案執行時間'
              : (
                <>
                  <Checkbox
                    checked
                    disabled
                  />
                  <span className={batchStyles.paddingLeft}>
                    預約修改圖片提案執行時間
                  </span>
                </>
              )
            }
            <When
              value={!_.isEmpty(executeTs)}
              isTrue
            >
              <span className={batchStyles.batchTime}>
                {convertDateByMoment(executeTs, DATE_FORMAT.SCHEDULE)}
              </span>
              <Tip
                type='info'
                className={batchStyles.uploaderLabel}
              >
                {getExecuteBatchTypeStatus(proposal)}
              </Tip>
            </When>
          </Col>
          <Col span={11}>
            <When
              value={!_.isEmpty(revertTs)}
              isTrue
            >
              <Checkbox
                checked={revertTs}
                disabled
              />
              <span className={batchStyles.paddingLeft}>設定自動回檔</span>
              <span className={batchStyles.batchTime}>
                {convertDateByMoment(revertTs, DATE_FORMAT.SCHEDULE)}
              </span>
              <Tip type='info'>
                {getRevertBatchTypeStatus(proposal)}
              </Tip>
            </When>
          </Col>
          <Col
            span={3}
            style={{ textAlign: 'right' }}
          >
            <Button
              size='medium'
              buttonType='outline'
            >
              {executeStatus === PROPOSAL_EXECUTE_STATUS.IDLE
                ? '尚未開始'
                : PROPOSAL_EXECUTE_STATUS_MAP[executeStatus]}
              {revertStatus === PROPOSAL_EXECUTE_STATUS.IDLE &&
                executeStatus !== PROPOSAL_EXECUTE_STATUS.IDLE
                ? '待回檔'
                : revertStatus === PROPOSAL_EXECUTE_STATUS.FINISHED
                  ? '已回檔'
                  : ''}
            </Button>
          </Col>
        </Row>
      )}
    >
      <Row
        gutter={24}
        style={{ margin: '12px 0' }}
      >
        <ProposalDetails
          details={details}
          batchId={batchId}
          revertTs={revertTs}
        />
      </Row>
      <div style={{ margin: '0 12px' }}>
        { // 整批取消：「尚未開始」之批次才顯示
          executeStatus === PROPOSAL_EXECUTE_STATUS.IDLE && (
            <Button
              size='large'
              buttonType='outline'
              onClick={onCancelBatch}
            >
              {ACTION_TYPES[ACTION_TYPE_CANCEL_BATCH]}
            </Button>
          )}
        { // 立即回檔：「已執行待回檔」之批次才顯示
          executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED &&
          revertStatus === PROPOSAL_EXECUTE_STATUS.IDLE && (
            <Button
              size='large'
              buttonType='outline'
              onClick={onInstantRevert}
              disabled={restProposal.revertSubmitted}
            >
              {ACTION_TYPES[ACTION_TYPE_INSTANT_REVERT]}
            </Button>
          )}
        { // 取消回檔：有「設定自動回檔」且狀態為「尚未開始」、「已執行待回檔」之批次才顯示
          revertStatus === PROPOSAL_EXECUTE_STATUS.IDLE && (
            <Button
              size='large'
              buttonType='outline'
              onClick={onCancelRevert}
            >
              {ACTION_TYPES[ACTION_TYPE_CANCEL_REVERT]}
            </Button>
          )}
        { // 調整圖片修改執行時間：「尚未開始」之批次才顯示
          executeStatus === PROPOSAL_EXECUTE_STATUS.IDLE && (
            <Button
              type='primary'
              size='large'
              buttonType='outline'
              onClick={e => onAdjustTime(e, BATCH_PROPOSAL_TYPE.EXECUTE)}
            >
              {ACTION_TYPES[ACTION_TYPE_ADJUST_EXECUTE]}
            </Button>
          )}
        { // 修改回檔時間：有「設定自動回檔」且狀態為「尚未開始」、「已執行待回檔」之批次才顯示
          revertStatus === PROPOSAL_EXECUTE_STATUS.IDLE && (
            <Button
              type='primary'
              size='large'
              buttonType='outline'
              onClick={e => onAdjustTime(e, BATCH_PROPOSAL_TYPE.REVERT)}
            >
              {ACTION_TYPES[ACTION_TYPE_ADJUST_REVERT]}
            </Button>
          )}
      </div>
      <Modal
        className={styles.modal}
        visible={!!openModal}
        onOk={onOK}
        onCancel={onCancel}
        okText={okLable}
        okButtonDisabled={isLoading}
        cancelText={cancelLable}
        title={modalTitle}
      >
        {modalContent}
        <When
          value={openModal === ACTION_TYPE_ADJUST_EXECUTE || openModal === ACTION_TYPE_ADJUST_REVERT}
          isTrue
        >
          <DatePicker
            showTime
            placeholder={
              openModal === ACTION_TYPE_ADJUST_EXECUTE
                ? '選擇預約執行時間'
                : '選擇回檔時間'
            }
            format={DATE_FORMAT.SCHEDULE}
            value={newAdjTs}
            disabledDate={current => {
              if (current) {
                return current < moment().startOf('day') ||
                  current > moment().add(
                    openModal === ACTION_TYPE_ADJUST_EXECUTE
                      ? 30
                      : 60,
                    'days'
                  )
              }
              return false
            }}
            onChange={date => setAdjTs(date)}
          />
          <Tip
            type='info'
            className={batchStyles.uploaderLabel}
          >
            {BATCH_TYPE_LIMIT_MAP[
              openModal === ACTION_TYPE_ADJUST_EXECUTE
                ? BATCH_PROPOSAL_TYPE.EXECUTE
                : BATCH_PROPOSAL_TYPE.REVERT]}
          </Tip>
        </When>
      </Modal>
    </CollapsePanel>
  )
}

const ProposalDetails = ({ details = [], revertTs, batchId }) => {
  const isContainsRevert = !!revertTs
  return ([
    BATCH_PROPOSAL_TYPE.EXECUTE,
    ...(isContainsRevert ? [BATCH_PROPOSAL_TYPE.REVERT] : [])
  ]).map((proposalType, index) => (
    <Col
      span={12}
      key={index}
    >
      <Card
        type='inner'
        title={proposalType === BATCH_PROPOSAL_TYPE.EXECUTE ? '修改圖片提案資訊' : '回檔提案資訊'}
        extra={(
          <HyperLink
            href={getBatchProposalLink(batchId, proposalType)}
            target='_blank'
          >
            批次提案檢視-
            {proposalType === BATCH_PROPOSAL_TYPE.EXECUTE ? '修改圖片' : '回檔'}
          </HyperLink>
        )}
      >
        {details.map((detail, index) => {
          const proposalId = detail[`${proposalType}ProposalId`]
          return (
            <div key={index}>
              修改圖片提案編號：
              <HyperLink
                href={getProposalLink(proposalId)}
                target='_blank'
              >
                {proposalId}
              </HyperLink>
              、查看賣場：
              <ConnectedListingLink
                targetListingId={detail.listingId}
              >
                {detail.listingId}
              </ConnectedListingLink>
              <br/>
            </div>
          )
        })}
      </Card>
    </Col>
  ))
}

const hoc = component => withI13nWrapper(component)

export default hoc(BatchProposalQueryMain)
